<template>
  <!-- 用能查询 -->
  <el-row class="peak-valley-analysis flex-grow-1" type="flex" :gutter="12">
    <el-col :span="5" class="tree-container d-flex flex-column">
      <project-tree-selector
        class="flex-grow-1"
        @select-node="selectNodeListener"
        @node-list="nodeListChangeListener"
      ></project-tree-selector>
    </el-col>
    <!-- 右側 -->
    <el-col :span="19" class="d-flex flex-column">
      <div class="breadcrumbs-contain d-flex align-items-center section-container"
      :class="{'dark':skinType}">
        <SectionTitle title="峰谷分析"></SectionTitle>
        <breadcrumbs
          :selectNode="selectNode"
          :nodeList="nodeList"
        ></breadcrumbs>
      </div>
      <!-- 條件查詢 -->
      <div class="selector-container section-container" :class="{'dark':skinType}">
        <el-form :inline="true" style="text-align: left" size="small">
          <period-date-selector
            :isDateSelector="false"
            @startEndDate="startEndDateListener"
          ></period-date-selector>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button  @click="exportTable">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table  size="small"
        class="energy-table flex-grow-1 d-flex flex-column"
        :data="tableData"
        height="0"
        stripe
                style="width: 100%"
        ref="table"
        :class="{'dark':skinType}"
        :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
      >
        <el-table-column prop="PointName" label="监测点" min-width="120"> </el-table-column>
        <el-table-column prop="Total" label="总(kWh)"> </el-table-column>
        <el-table-column prop="Sharp" label="尖(kWh)"> </el-table-column>
        <el-table-column prop="Sharp_Rate" label="尖比重(%)"> </el-table-column>
        <el-table-column prop="Peak" label="峰(kWh)"> </el-table-column>
        <el-table-column prop="Peak_Rate" label="峰比重(%)"> </el-table-column>
        <el-table-column prop="Flat" label="平(kWh)"> </el-table-column>
        <el-table-column prop="Flat_Rate" label="平比重(%)"> </el-table-column>
        <el-table-column prop="Valley" label="谷(kWh)"> </el-table-column>
        <el-table-column prop="Valley_Rate" label="谷比重(%)">
        </el-table-column>
        <el-table-column prop="Date" label="监测日期" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.Date.split(" ")[0] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="d-flex section-container" :class="{'dark':skinType}">
        <el-pagination
		  :page-size="pageInfo.size"
          v-if="pageInfo.total"
          style="margin-left: auto"
          background
          :class="{'text-white':skinType}"
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          :current-page.sync="pageIndex"
        >
        </el-pagination>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import ProjectTreeSelector from '@/components/utils/project-tree-selector.vue';
import PeriodDateSelector from '@/components/energy-analysis/components/period-date-selector.vue';
import { peakValleyAnalysis } from '@/api/statistic/statistic';
import Breadcrumbs from '@/components/utils/breadcrumbs.vue';
import { exportExcel } from '@/utils/utils';
import equipDateTypeMixin from '@/components/energy-analysis/mixin/mixin';
import SectionTitle from '@/components/utils/section-title.vue';

export default {
  name: 'peak-valley-analysis',
  components: {
    ProjectTreeSelector,
    PeriodDateSelector,
    Breadcrumbs,
    SectionTitle,
  },
  mixins: [equipDateTypeMixin],
  data() {
    return {
      pageIndex: 1,
      startEndDate: null,
      selectNode: null,
      pageInfo: {
        index: 1,
        size: 40,
        total: 0,
      },
      tableData: [],
      options: [
        {
          label: '上日',
          value: 0,
        },
        {
          label: '上周',
          value: 1,
        },
        {
          label: '上月',
          value: 2,
        },
        {
          label: '上年',
          value: 3,
        },
      ],
      compareDateType: 0,
      nodeList: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    pageIndex() {
      this.requestPeakValleyAnalysis();
    },
    selectNode() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      // if (this.isDateSelectorChange(newVal, oldVal)) {
      //   return;
      // }
      this.requestPeakValleyAnalysis();
    },
    startEndDate() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestPeakValleyAnalysis();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    nodeListChangeListener(list) {
      this.nodeList = list;
    },
    selectNodeListener(node) {
      this.pageIndex = 1;
      this.selectNode = node;
    },
    startEndDateListener(datePeriod) {
      this.startEndDate = datePeriod;
    },
    requestPeakValleyAnalysis() {
      if (this.startEndDate === null) {
        return;
      }
      if (this.selectNode === null) {
        return;
      }
      // if (!this.isDateOfEquip(this.selectNode.oType, this.startEndDate.isDateSelector)) {
      //   return;
      // }
      peakValleyAnalysis({
        oType: this.selectNode.oType,
        oIDstr: this.selectNode.IdStr,
        BeginDate: this.startEndDate.start,
        EndDate: this.startEndDate.end,
        page: this.pageIndex,
        rows: this.pageInfo.size,
      }).then((res) => {
        if (res !== null && res.list) {
		   // res.list.forEach(item => {
			  //  item.Flat_Rate = item.Flat_Rate.toFixed(2)
			  //  item.Peak_Rate = item.Peak_Rate.toFixed(2)
		   // })
           this.tableData = res.list;
           this.pageInfo.total = res.total;
          return;
        }else if(res.length){
          this.tableData = res;
          return;
        }
        this.tableData = res || [];
        this.pageInfo.total = 0;
      }).catch(() => {
        this.tableData = [];
        this.pageInfo.total = 0;
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onSubmit() {
      this.requestPeakValleyAnalysis();
    },
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
  },
};
</script>
<style scoped>
.breadcrumbs-contain {
  padding: 1rem;
  margin-bottom: 1rem;
}
</style>
